import { ApiError } from "@/api/api-axios";
import { PasswordInput } from "@/components/password-input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { confirmResetPasswordApi } from "../api/api-auth";
export function ResetPasswordForm({
  className,
  ...props
}: React.ComponentProps<"form">) {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<{
    type: "success" | "error";
    text: string;
  } | null>(null);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  console.log("token", token);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);
    setIsLoading(true);

    try {
      if (!token) {
        setMessage({
          type: "error",
          text: "Đã xảy ra lỗi, vui lòng thử lại!",
        });
        return;
      }
      const response = await confirmResetPasswordApi(token, password);
      if (response.success) {
        setMessage({
          type: "success",
          text: "Đã cập nhật mật khẩu thành công, vui lòng đăng nhập lại",
        });
      } else {
        setMessage({
          type: "error",
          text: (response.message as string) || "Đã xảy ra lỗi, vui lòng thử lại!",
        });
      }
    } catch (err: unknown) {
      const apiError = err as ApiError;
      setMessage({
        type: "error",
        text: (apiError.data?.message as string) || "Đã xảy ra lỗi, vui lòng thử lại!",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      className={cn("flex flex-col gap-6 p-6 bg-white rounded-lg border border-gray-200", className)}
      onSubmit={handleSubmit}
      {...props}
    >
      <div className="flex flex-col gap-2">
        <p className="">Đổi mật khẩu,</p>
        <h1 className="text-gray-800 text-2xl font-bold">
          <span className="font-bold text-primary">ABT</span>
        </h1>
      </div>

      {message && (
        <div
          className={`mb-4 p-3 rounded-md text-sm ${message.type === "success"
            ? "bg-green-50 text-green-800 border border-green-200"
            : "bg-red-50 text-red-800 border border-red-200"
            }`}
        >
          {message.text}
        </div>
      )}
      <div className="grid gap-6">
        <div className="grid gap-3">
          <Label htmlFor="password">Mật khẩu mới</Label>
          <PasswordInput
            id="newPassword"
            placeholder="Nhập mật khẩu mới"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={isLoading}
          />
        </div>
        <div className="grid gap-3">
          <Label htmlFor="confirmPassword">Xác nhận mật khẩu</Label>
          <PasswordInput
            id="confirmPassword"
            placeholder="Nhập lại mật khẩu mới"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            disabled={isLoading}
          />
        </div>

        <Button type="submit" className="w-full" disabled={isLoading || password !== confirmPassword}>
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Đang cập nhật...
            </>
          ) : (
            "Cập nhật"
          )}
        </Button>
        <div className="text-center text-sm">
          <span className="text-muted-foreground">Đã có tài khoản? </span>
          <Link
            to="/login"
            className="text-gray-600 hover:text-gray-700 font-medium hover:underline"
          >
            Đăng nhập ngay
          </Link>
        </div>
      </div>

      <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-lg">
        <p className="text-sm text-gray-600 font-medium mb-2">
          Sau khi cập nhật mật khẩu, vui lòng đăng nhập lại
        </p>
      </div>
    </form>
  );
}
